export default {
  path: 'manage-objective-kpi',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Manage Objective KPI',
      component: () => import('@/views/menus/manageObjectiveKpi/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
